import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function useOrderTransfer({ csrfToken, transferUrl, onTransferred }) {
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const submit = ({ firstName, lastName, email, note, ticketIds }) => {
    setSubmitting(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios.post(transferUrl, {
      ticket_transfer: {
        first_name: firstName,
        last_name: lastName,
        email,
        note,
        ticket_transfer_tickets_attributes: ticketIds.map((id) => ({ ticket_id: id })),
      },
    })
      .then(() => {
        toast.success('Transfer started', { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        if (onTransferred) onTransferred();
      })
      .catch((error) => {
        const data = error.response && error.response.data;
        const msg = data && data.errors ? [].concat(data.errors).join(', ') : 'Could not transfer tickets. Please try again.';
        toast.error(msg, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      })
      .then(() => setSubmitting(false));
  };

  return { open, openModal, closeModal, submitting, submit };
}
